// extracted by mini-css-extract-plugin
export default {"wrapper":"Progress_wrapper__GSFOm","full_bar":"Progress_full_bar__00pKW","empty":"Progress_empty__NUITc"};